

import { Vue, Component, Prop } from 'vue-property-decorator'
import { IProduct } from '~/interfaces/product'
import AsyncAction from '~/components/shared/async-action.vue'
import AppLink from '~/components/shared/app-link.vue'
import Rating from '~/components/shared/rating.vue'
import Quickview16Svg from '~/svg/quickview-16.svg'
import Wishlist16Svg from '~/svg/wishlist-16.svg'
import Compare16Svg from '~/svg/compare-16.svg'

export type ProductCardLayout = 'grid-sm' | 'grid-nl' | 'grid-lg' | 'list' | 'horizontal';

@Component({
    components: { AsyncAction, Quickview16Svg, AppLink, Rating, Wishlist16Svg, Compare16Svg }
})
export default class ProductCard extends Vue {
    @Prop({ type: Object, required: true }) readonly product!: IProduct
    @Prop({ type: String, default: () => undefined }) readonly layout!: ProductCardLayout

    get features () {
        return this.product.attributes.filter(x => x.featured)
    }
}

